import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Portal,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";

import { ChangeEvent, useEffect, useState } from "react";
import { RiSearch2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import { CreateBadgeModal } from "../../../components/admin/badges/CreateBadgeModal";
import { EditBadgeModal } from "../../../components/admin/badges/EditBadgeModal";
import {
  IBadgesData,
  IBadgesRes,
} from "../../../models/admin/badges/badges.model";
import BadgeService from "../../../services/admin/badge.service";

const Badges = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [fileteredBadges, setFilteredBadges] = useState<IBadgesData[]>([]);
  const [badgeList, setbadgeList] = useState<IBadgesData[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [isEditbadge, setisEditbadge] = useState(false);
  const [isbadge, setisbadge] = useState(false);
  const [badge, setbadge] = useState<IBadgesData>();
  const [badgeName, setbadgeName] = useState<string>();

  useEffect(() => {
    // let url = `?pageNumber=${currentPage}&pageSize=${100}&searchString=${query}`
    BadgeService.getActiveBadges()
      .then((data) => {
        const system_badge: IBadgesRes = data;
        //setPage({ page_total: system_param.pageSize, total: system_param.totalCount, page_count: system_param.totalPages })
        setbadgeList(system_badge.data);
        setFilteredBadges(system_badge.data);
        setIsLoading(false);
      })
      .catch((err) => err);
  }, [query, reload]);

  const openbadge = () => {
    setisEditbadge(false);
    setisbadge(true);
  };
  const openEditbadge = (param: any) => {
    setbadge(param);
    setisEditbadge(true);
    setisbadge(false);
  };

  const reloadData = () => {
    setReload(!reload);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredBadges(badgeList);
    } else {
      if (badgeList) {
        const filtered = badgeList.filter((each: any) =>
          each.name.toLowerCase().includes(searchTerm)
        );
        setFilteredBadges(filtered);
      }
    }
  };

  return (
    <>
      {
        <Flex
          minHeight={"100vh"}
          height={"auto"}
          boxSizing="border-box"
          maxWidth={"100hw"}
        >
          <Box
            width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>
          <Box width="100%">
            <AdminDashboardHeader />
            <Box
              pt="30px"
              px={["20px", "30px"]}
              width={"100%"}
              bg="#F9F8F8"
              height={"auto"}
              minHeight={"95vh"}
              maxHeight={"95vh"}
              overflowX={"scroll"}
              className="scroll-hidden"
            >
              <Flex
                justifyContent="space-between"
                alignItems="baseline"
                py="26px"
              >
                <Text color="#2B2B2B" fontWeight="800" fontSize="27px">
                  Badges
                </Text>
                <Button
                  colorScheme={"red"}
                  py="7px"
                  px="10px"
                  borderRadius={"2px"}
                  fontSize={12}
                  onClick={() => {
                    openbadge();
                  }}
                >
                  {" "}
                  Create Badge
                </Button>
              </Flex>
              <Box width="100%">
                <Box>
                  <Flex py="15px" justifyContent="">
                    <InputGroup
                      bg="white"
                      width={["90%", "90%", "50%", "30%"]}
                      mr="20px"
                    >
                      <Input
                        height="40px"
                        onChange={(e) => handleSearchChange(e)}
                        placeholder="Search input here"
                        fontSize={12}
                        size="sm"
                      />
                      <InputRightElement
                        pointerEvents="none"
                        children={<RiSearch2Line color="red" size="0.9rem" />}
                      />
                    </InputGroup>
                  </Flex>
                  <Box width={"100%"}>
                    <TableContainer>
                      <Table size={"sm"}>
                        <Thead py={"15px"}>
                          <Tr bg="white" py={"15px"}>
                            <Td py={"15px"} textTransform={"capitalize"}>
                              {" "}
                              Name
                            </Td>
                            <Td textTransform={"capitalize"}>Description </Td>
                            <Td textTransform={"capitalize"}>Type</Td>
                            <Td textTransform={"capitalize"}>Created At</Td>
                            <Td textTransform={"capitalize"}>Actions</Td>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {fileteredBadges &&
                            fileteredBadges.length > 0 &&
                            fileteredBadges.map((badge, index: number) => (
                              <Tr bg="white" key={index}>
                                <Td>
                                  <Text
                                    fontSize={"13px"}
                                    textTransform={"capitalize"}
                                  >
                                    {badge.name}
                                  </Text>
                                </Td>
                                <Td>
                                  <Text
                                    fontSize={"13px"}
                                    textTransform={"capitalize"}
                                  >
                                    {badge.description
                                      ? badge.description
                                      : "Nil"}
                                  </Text>
                                </Td>

                                <Td>
                                  <Text
                                    fontSize={"13px"}
                                    textTransform={"capitalize"}
                                  >
                                    {badge.type}
                                  </Text>
                                </Td>
                                <Td>
                                  <Text
                                    fontSize={"13px"}
                                    textTransform={"capitalize"}
                                  >
                                    {badge.created_at}
                                  </Text>
                                </Td>
                                <Td>
                                  <HStack>
                                    <Button
                                      cursor="pointer"
                                      colorScheme="red"
                                      size={"sm"}
                                      fontSize={"13px"}
                                      onClick={() => {
                                        openEditbadge(badge);
                                      }}
                                    >
                                      Edit
                                    </Button>
                                  </HStack>
                                </Td>
                              </Tr>
                            ))}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Box>
                  {isbadge && (
                    <Portal>
                      {" "}
                      <CreateBadgeModal
                        isOpenbadge={isbadge}
                        onClosed={setisbadge}
                        isbadge={isbadge}
                        reload={reloadData}
                      />{" "}
                    </Portal>
                  )}
                  {isEditbadge && (
                    <Portal>
                      {" "}
                      <EditBadgeModal
                        isOpenEditbadge={isEditbadge}
                        onClosed={setisEditbadge}
                        isEditbadge={isEditbadge}
                        reload={reloadData}
                        badge={badge}
                      />{" "}
                    </Portal>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Flex>
      }
    </>
  );
};

export default Badges;
